import { render, staticRenderFns } from "./custompagedtable.vue?vue&type=template&id=899888b8&"
import script from "./custompagedtable.vue?vue&type=script&lang=js&"
export * from "./custompagedtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports